export default "__VITE_ASSET__Bcv34J_u__"